import React from 'react';
import { cn } from '../../lib/utils';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', size = 'md', className, to, ...props }) => {
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark shadow-md hover:shadow-lg hover:shadow-primary/20 border border-transparent',
    secondary: 'bg-secondary text-white hover:bg-secondary-dark shadow-md hover:shadow-lg hover:shadow-secondary/20 border border-transparent',
    outline: 'bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-white',
    white: 'bg-white text-primary hover:bg-gray-50 shadow-md hover:shadow-lg border border-gray-100',
    ghost: 'bg-transparent text-primary hover:bg-primary/5',
  };

  const sizes = {
    sm: 'px-5 py-2 text-sm font-medium',
    md: 'px-7 py-3 text-base font-semibold',
    lg: 'px-9 py-4 text-lg font-bold',
  };

  const classes = cn(
    'inline-flex items-center justify-center rounded-full transition-all duration-300 disabled:opacity-50 disabled:pointer-events-none tracking-wide',
    variants[variant],
    sizes[size],
    className
  );

  const motionProps = {
    whileHover: { scale: 1.03, y: -2 },
    whileTap: { scale: 0.97 },
  };

  if (to) {
    return (
      <Link to={to}>
        <motion.div className={classes} {...motionProps} {...props}>
          {children}
        </motion.div>
      </Link>
    );
  }

  return (
    <motion.button className={classes} {...motionProps} {...props}>
      {children}
    </motion.button>
  );
};

export default Button;